import { render, staticRenderFns } from "./PhotoThumbs.vue?vue&type=template&id=3e20c5a2&scoped=true&"
import script from "./PhotoThumbs.vue?vue&type=script&lang=js&"
export * from "./PhotoThumbs.vue?vue&type=script&lang=js&"
import style0 from "./PhotoThumbs.vue?vue&type=style&index=0&id=3e20c5a2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e20c5a2",
  null
  
)

export default component.exports